export class ObterArquivoCadernoIdInputDto{
  id: number;
  pagina?: number;

  constructor(id: number, pagina?: number) {
    this.id = id;
    this.pagina = pagina;
  }
}
